import { findTermsOfUseLink } from "@/lib/enums/terms-of-use-type";

import type { JSX } from "react";

interface ReservedScheduleTermsOfUseUrlProps {
  /**
   * Aceita `null`/`undefined` porque os dois sítios de cancelamento leem
   * `nextSchedule?.codModalidadePeriodoGarantido`, que pode não ter chegado ainda. Antes eles
   * mascaravam isso com `?? 0`, o que produzia um `<a href={undefined}>` — um link clicável que
   * não navega para lugar nenhum.
   */
  reservedScheduleType: number | null | undefined;
  title?: string;
}

/**
 * O mapa de links saiu daqui para `@/lib/enums/terms-of-use-type` na KRA-516: o campo de categoria
 * precisa da **mesma** informação para decidir o que oferecer, e ter a lista privada aqui obrigaria
 * a duplicá-la. Careplus, Sami e Saludia continuam sem artigo publicado — ver
 * `hasPublishedTermsOfUseLink`.
 */
export const ReservedScheduleTermsOfUseUrl = ({
  reservedScheduleType,
  title = "Ler termos e condições",
}: ReservedScheduleTermsOfUseUrlProps): JSX.Element => {
  const href = findTermsOfUseLink(reservedScheduleType);

  // Sem link conhecido, renderiza texto puro em vez de uma âncora morta: o texto continua
  // informando, mas não promete uma navegação que não existe.
  if (!href) {
    return <span data-testid="terms-of-use-link">{title}</span>;
  }

  return (
    <a
      data-testid="terms-of-use-link"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="text-[#0080a5] underline"
    >
      <span>{title}</span>
    </a>
  );
};
